export const CUSTOM_FRESHCHAT_ID_CLASSNAME = {
  FRAME_ID: 'fc_frame', // *: fc_frame is default ID of Freshchat
  CONTAINER_ID: 'custom-freshchat-container',
  BUTTON_ID: 'custom-freshchat-btn',
  HOTLINE_ICON_ID: 'hotline-icon',
  NOTIFY_ID: 'notify',
};

export const FRESHCHAT_TIMEOUT = 8;
